const cards = [
  {
    title: '2026暑期电影市场全面回暖，多部大片口碑票房双丰收',
    desc: '今年的暑期档可谓竞争激烈，多部大制作影片接连上映，观众反响热烈，中国电影市场迎来新一轮增长高峰。',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20breaking%20news%20concept%20with%20smartphone%20displaying%20headlines%20on%20wooden%20desk%20warm%20ambient%20lighting%20modern%20digital%20lifestyle%20editorial%20photography%20clean%20aesthetic&width=500&height=350&seq=info-card-01&orientation=landscape',
    tag: '影视',
    date: '2026-07-30',
  },
  {
    title: '流量明星转型之路：从偶像到实力派的进阶之路',
    desc: '近年来多位年轻艺人凭借扎实演技实现职业跨越，背后是多年积累与精心选戏的策略，值得行业关注。',
    image: 'https://readdy.ai/api/search-image?query=Film%20festival%20outdoor%20venue%20with%20decorative%20elements%20and%20warm%20sunset%20lighting%20cinematic%20atmosphere%20sophisticated%20event%20photography%20elegant%20composition&width=500&height=350&seq=info-card-02&orientation=landscape',
    tag: '明星',
    date: '2026-07-29',
  },
  {
    title: '音乐综艺新玩法：创新赛制让经典歌曲焕发新生',
    desc: '各平台音乐类综艺推陈出新，融入竞技、改编、跨界等元素，让经典旋律以全新面貌触动新一代观众。',
    image: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20interior%20with%20professional%20equipment%20warm%20ambient%20lighting%20creative%20workspace%20atmosphere%20modern%20design%20clean%20aesthetic&width=500&height=350&seq=info-card-03&orientation=landscape',
    tag: '音乐',
    date: '2026-07-28',
  },
  {
    title: '时尚圈新趋势：可持续时尚成为红毯造型新选择',
    desc: '从国际电影节到各大颁奖礼，越来越多的明星选择环保材质的礼服亮相，引领绿色时尚新风潮。',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20show%20scene%20with%20dramatic%20spotlight%20and%20elegant%20atmosphere%20warm%20lighting%20sophisticated%20event%20photography%20editorial%20style&width=500&height=350&seq=info-card-04&orientation=landscape',
    tag: '时尚',
    date: '2026-07-27',
  },
  {
    title: '网剧精品化趋势明显：小成本也能拍出大质感',
    desc: '多部网剧凭借精良制作和扎实剧本口碑逆袭，证明优质内容才是吸引观众的根本，也为行业注入信心。',
    image: 'https://readdy.ai/api/search-image?query=Television%20award%20trophy%20on%20illuminated%20pedestal%20with%20warm%20golden%20lighting%20prestigious%20entertainment%20ceremony%20atmosphere%20elegant%20minimal%20composition&width=500&height=350&seq=info-card-05&orientation=landscape',
    tag: '剧集',
    date: '2026-07-26',
  },
  {
    title: '下半年娱乐前瞻：这些即将发生的大事值得关注',
    desc: '从颁奖季到新剧定档，从演唱会巡回到综艺录制，下半年娱乐圈将迎来一系列值得期待的精彩内容。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20content%20creation%20workspace%20with%20laptop%20and%20creative%20tools%20warm%20ambient%20lighting%20modern%20lifestyle%20photography%20editorial%20style%20clean%20aesthetic&width=500&height=350&seq=info-card-06&orientation=landscape',
    tag: '前瞻',
    date: '2026-07-25',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热点资讯
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              深度解读娱乐圈最受关注的热门话题
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cards.map((card) => (
              <div
                key={card.title}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] border border-background-200/60"
              >
                <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <span className="text-xs text-foreground-500 mb-2 block whitespace-nowrap">{card.date}</span>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug mb-2 line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}